<template>
  <scout-form
    :is-modified="!!value.length"
    label="スキル"
  >
    <div class="boss-layout boss-layout-start boss-layout-gap-large">
      <label
        v-for="(option, i) in options"
        :key="i"
        :data-test="`label-${i}`"
        class="pega-input"
      >
        <input
          :checked="selectedOption === option.key"
          :value="option.key"
          :data-test="`radio-${i}`"
          class="boss-input-checkbox"
          type="radio"
          @change="$emit('update:selectedOption', $event.target.value)"
        >{{ option.label }}
      </label>
    </div>
    <select-modal-button
      v-if="skillsMaster.length > 0"
      :master-data="skillsMaster"
      :experience-range-options="experienceOptions"
      :default-experience-id="defaultExperienceId"
      :selected-items="value.map(o => { return { id: o.id, experience: o.years.minimum } })"
      title="スキル"
      suffix="skills"
      data-test="modal"
      @update-modal-checked-ids="value => $emit('input', value.map(o => { return { id: o.id, years: { minimum: o.experience ? Number(o.experience) : Number(defaultExperienceId) } }}))"
    />
  </scout-form>
</template>

<script>
import ScoutForm from '@/components/atoms/ScoutForm'
import SelectModalButton from '@/components/organisms/SelectModalButton'
import * as definition from '@/lib/labelValueMappings'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    ScoutForm,
    SelectModalButton
  },
  props: {
    selectedOption: {
      default: 'and',
      type: String
    },
    value: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      options: [
        { key: 'and', label: 'すべてを含む' },
        { key: 'or', label: 'いずれかを含む' }
      ],
      experienceOptions: definition.searchSkillExperienceRange
    }
  },
  computed: {
    ...mapGetters([
      'skillsMaster'
    ]),
    defaultExperienceId () {
      return _.head(this.experienceOptions).id
    }
  }
}
</script>
